import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { testConfig } from '../../docs-routes'

const TestConfigCustomTimeoutDescription = () =>
  <>
    <Header
      hasNoTopMargin
      rank={4}
    >
      Custom max run time
    </Header>
    <Paragraph>
      Enter a whole number from 1 minute to 168 hours (1 week). Both fields cannot be zero same time.
    </Paragraph>
    <br />
    <LinkToDocusaurus path={testConfig}>
      Learn more in the DAI documentation
    </LinkToDocusaurus>
  </>

export default TestConfigCustomTimeoutDescription
